import * as React from "react";

import { cn } from "~/lib/ui/utils/utils";

export type InputProps = React.ComponentProps<"input"> & {
  error?: string | null;
  hasError?: boolean;
  hint?: string;
  hintClassName?: string;
  label?: React.ReactNode;
  labelClassName?: string;
  icon?: React.ReactNode;
  containerClassname?: string;
};

function Input({
  className,
  containerClassname,
  error,
  hasError,
  hint,
  hintClassName,
  icon,
  id,
  label,
  labelClassName,
  type,
  ...props
}: InputProps) {
  const generatedId = React.useId();
  const inputId = id ?? generatedId;

  return (
    <div
      className={cn(
        "w-full",
        (label || hint || error) && "flex flex-col gap-1.5",
        containerClassname,
      )}
    >
      {label && (
        <label
          className={cn("text-sm font-medium leading-none", labelClassName)}
          htmlFor={inputId}
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-2 top-1/2 -translate-y-1/2">{icon}</div>
        )}
        <input
          className={cn(
            `
              flex h-10 w-full rounded-md border border-input bg-background px-3
              py-2 text-sm

              disabled:cursor-not-allowed disabled:opacity-50

              file:border-0 file:bg-transparent file:text-sm file:font-medium

              focus-visible:outline-hidden focus-visible:border-foreground/40

              placeholder:text-muted-foreground
            `,
            (error ?? hasError) && "border-detail-failure",
            icon && "pl-7",
            className,
          )}
          id={inputId}
          type={type}
          autoComplete={type === "password" ? "current-password" : "off"}
          {...props}
        />
      </div>
      {error && <p className="text-sm text-detail-failure">{error}</p>}
      {hint && (
        <p className={cn("text-xs text-muted-foreground", hintClassName)}>
          {hint}
        </p>
      )}
    </div>
  );
}

export { Input };
